// export const baseUrl =  'http://127.0.0.1:8000/';  // Api Service
// export const baseUrl1 = 'http://127.0.0.1:5001/'; // Background Service
export const baseUrl = 'https://api.exdionistudiostg.com/';  // Api Service
export const baseUrl1 = 'https://background.exdionistudiostg.com/'; // Background Service
export const ClientID = '33350e5b-87cb-458e-8216-720d2664ac08';
export const SecretKey = 'CGW8Q~054Nw.-bKUsjfv4rfwoO3hjXjPjzNurbal';
export const bucketName = 'istduio';
export const load = window.location;
export const GridUrl = 'https://www.exdion-itest.studio/xlpage?jobId';
export const GridQcUrl = 'https://www.exdion-itest.studio/qcJob?jobId';
export const sidebarGridUrl = 'https://www.exdion-itest.studio/job?user';
export const privacyNotice = 'https://exdionedge.tech/helpfiles/PrivacyPolicy.pdf';
export const brokerIdsToShowPrimaryUser = [1003];

export const handleDownload = (fileUrl: any, fileName: any) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const newstatusValueArray: Record<number, string> = {
    1: "Pending",
    2: "InProgress",
    3: "FileProcessing",
    4: "FileProcessing Completed",
    5: "FileProcessing Failed",
    6: "MoveToExtraction InProgress",
    7: "MoveToExtraction Completed",
    8: "MoveToExtractionFailed",
    9: "Extraction InProgress",
    10: "Extraction Completed",
    11: "Extraction Failed",
    12: "DataMigration InProgress",
    13: "DataMigration Completed",
    14: "DataMigration Failed",
    15: "Data Processing InProgress",
    16: "Data Processing Completed",
    17: "Data Processing Failed",
    18: "Grid Data Integration InProgress",
    19: "Grid Data Integration Completed",
    20: "Grid Data Integration Failed",
    21: "Checklist Generation InProgress",
    22: "Checklist Generation Completed",
    23: "Checklist Generation Failed",
    24: "Success",
    25: "Dispatch InProgress",
    26: "Dispatched",
    27: "Dispatch Failed",
    28: "AutoJobCreation Failed",
    29: "Failed To Process",
    30: "Ready To Dispatch",
    31: "Ready To Dispatch Failed"
};
export const Dispatchstatus: Record<number, string> = {
    25: "Dispatch InProgress",
    26: "Dispatched",
    27: "Dispatch Failed"
};

export const rolenum: Record<string, number> = {
    ExdionAdmin: 1,
    BrokerAdmin: 2,
    CSR: 3,
    Reviewer: 4,
    MSUser: 5,
    Supervisor: 6,
    QA: 7,
    csruser: 12
};

export enum JobInfoStatusEnum {
    Pending = 1,
    InProgress = 2,
    FileProcessing = 3,
    FileProcessingCompleted = 4,
    FileProcessingFailed = 5,
    MoveToExtractionInProgress = 6,
    MoveToExtractionCompleted = 7,
    MoveToExtractionFailed = 8,
    ExtractionInProgress = 9,
    ExtractionCompleted = 10,
    ExtractionFailed = 11,
    DataMigrationInProgress = 12,
    DataMigrationCompleted = 13,
    DataMigrationFailed = 14,
    DataProcessingInProgress = 15,
    DataProcessingCompleted = 16,
    DataProcessingFailed = 17,
    GridDataIntegrationInProgress = 18,
    GridDataIntegrationCompleted = 19,
    GridDataIntegrationFailed = 20,
    ChecklistGenerationInProgress = 21,
    ChecklistGenerationCompleted = 22,
    ChecklistGenerationFailed = 23,
    Success = 24,
    DispatchInProgress = 25,
    Dispatched = 26,
    DispatchFailed = 27,
    AutoJobCreationFailed = 28,
    FailedToProcess = 29,
    ReadyToDispatch = 30,
    ReadyToDispatchFailed = 31
};

export const statusValueFilterArray: Record<string, number> = {
    "Pending": 1,
    "InProgress": 2,
    "Completed": 3,
    "Failed": 4,
}

export const getStatusColorActivity = (statusId: any) => {
    switch (statusId) {
        case 1: // Pending
            return { bg: "#FEF3C7", text: "#D97706" }; // Light orange bg, Dark orange text
        case 3: // Completed
            return { bg: "#ECFDF5", text: "#047857" }; // Light green bg, Dark green text
        case 2: // InProgress
            return { bg: "#DBEAFE", text: "#1E40AF" }; // Light blue bg, Dark blue text
        case 4: // Failed
            return { bg: "#FEE2E2", text: "#B91C1C" }; // Light red bg, Dark red text
        default:
            return { bg: "#F3F4F6", text: "#6B7280" };
    }
};

export const getStatusColor = (statusId: number) => {
    switch (statusId) {
        case 1: // Pending
            return { bg: "#FEF3C7", text: "#D97706" };
        case 2: // InProgress
            return { bg: "#DBEAFE", text: "#1E40AF" };

        case 3: // FileProcessing
            return { bg: "#DBEAFE", text: "#1E40AF" };
        case 4: // FileProcessing Completed
            return { bg: "#ECFDF5", text: "#047857" };
        case 5: // FileProcessing Failed
            return { bg: "#FEE2E2", text: "#B91C1C" };

        case 6: // MoveToExtraction InProgress
            return { bg: "#DBEAFE", text: "#1D4ED8" };
        case 7: // MoveToExtraction Completed
            return { bg: "#ECFDF5", text: "#065F46" };
        case 8: // MoveToExtractionFailed
            return { bg: "#FEE2E2", text: "#DC2626" };

        case 9: // Extraction InProgress
            return { bg: "#DBEAFE", text: "#2563EB" };
        case 10: // Extraction Completed
            return { bg: "#ECFDF5", text: "#059669" };
        case 11: // Extraction Failed
            return { bg: "#FEE2E2", text: "#B91C1C" };

        case 12: // DataMigration InProgress
            return { bg: "#DBEAFE", text: "#1D4ED8" };
        case 13: // DataMigration Completed
            return { bg: "#ECFDF5", text: "#047857" };
        case 14: // DataMigration Failed
            return { bg: "#FEE2E2", text: "#DC2626" };

        case 15: // Data Processing InProgress
            return { bg: "#DBEAFE", text: "#1D4ED8" };
        case 16: // Data Processing Completed
            return { bg: "#ECFDF5", text: "#047857" };
        case 17: // Data Processing Failed
            return { bg: "#FEE2E2", text: "#B91C1C" };

        case 18: // Grid Data Integration InProgress
            return { bg: "#DBEAFE", text: "#2563EB" };
        case 19: // Grid Data Integration Completed
            return { bg: "#ECFDF5", text: "#10B981" };
        case 20: // Grid Data Integration Failed
            return { bg: "#FEE2E2", text: "#991B1B" };

        case 21: // Checklist Generation InProgress
            return { bg: "#DBEAFE", text: "#1E3A8A" };
        case 22: // Checklist Generation Completed
            return { bg: "#ECFDF5", text: "#047857" };
        case 23: // Checklist Generation Failed
            return { bg: "#FEE2E2", text: "#B91C1C" };

        case 24: // Success
            return { bg: "#ECFDF5", text: "#047857" };

        case 25: // Dispatch InProgress
            return { bg: "#FEF9C3", text: "#CA8A04" };
        case 26: // Dispatched
            return { bg: "#E5E7EB", text: "#111827" };
        case 27: // Dispatch Failed
            return { bg: "#FEE2E2", text: "#991B1B" };
        case 28: // AutoJobCreation Failed
            return { bg: "#fc8d6842", text: "#c68787" };
        case 29: // AutoJobCreation Failed
            return { bg: "#fc8d6842", text: "#c68787" };
        case 30: // Ready To Dispatch
            return { bg: "#DBEAFE", text: "#2563EB" };
        case 31: // Ready To Dispatch Failed
            return { bg: "#FEE2E2", text: "#B91C1C" };

        default:
            return { bg: "#F3F4F6", text: "#6B7280" }; // Default gray
    }
};


export const decodeJwt = (token: any) => {
    try {
        const payload = token.split('.')[1]; // JWT has 3 parts: header.payload.signature
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
                .join('')
        );
        // const parsedData = JSON.parse(jsonPayload)
        // parsedData["RoleId"] = 4;
        // return parsedData;
        return JSON.parse(jsonPayload);
    } catch (e) {
        console.error("Failed to decode JWT", e);
        return null;
    }
}

export enum UserRole {
    ExdionAdmin = 1,
    BrokerAdmin = 2,
    CSR = 3,
    Reviewer = 4,
    MSUser = 5,
    Supervisor = 6,
    QA = 7,
    csruser = 12,
}

export enum ComplianceFlag {
    commercialLine = 1,
    endorsementCheck = 2,
    personalLine = 3
}

export const applications = [
    {
        applicationId: 1,
        title: "Policy Check",
        heading: "InsurTech Solutions for the Digital Age Agency",
        description: (
            <>
                <span style={{ color: "red", fontWeight: 600 }}>
                    Policy Check
                </span>{" "}
                is an AI powered platform for automated policy checking to mitigate
                Agency wide E&O risk, customer dissatisfaction, and inefficiencies in
                real time.
            </>
        ),
        logo: "/policycheck.png",
    },
    {
        applicationId: 2,
        title: "Marketing",
        heading: "Marketing solution",
        description: (
            <>
                <span style={{ color: "red", fontWeight: 600 }}>
                    Quote summary
                </span>{" "}
                is an AI powered platform designed to perform automated quote comparison.
                It helps agencies in achieving process efficiency (time and effort
                saving) and accelerates next tasks of policy lifecycle like quote summary
                and proposal generation activities.
            </>
        ),
        logo: "/qcomp.png",
    },
    {
        applicationId: 3,
        title: "User Management",
        heading: "User Management - Manage application users",
        description: (
            <>
                <span style={{ color: "red", fontWeight: 600 }}>
                    User Management
                </span>{" "}
                is made easy with the centralized user creation, modification, deactivation and role changes
            </>
        ),
        logo: undefined,
    },
];

export enum ApplicationEnum {
    PolicyCheck = 1,
    QuoteCompare = 2,
    UserManagement = 3
}

export const adminScreenConfig = 'table1,table2,table3,table4,table5,table6,table7,table8,table9,table10,table11,table12';